module.exports = __webpack_public_path__ + "static/media/1012386.7214c19c.png";